/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceActivityEvent {
    getFixupPrototypeFunction() { return InfraResourceActivityEvent.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceActivityEvent>): InfraResourceActivityEvent {
        let obj = Object.assign(new InfraResourceActivityEvent(), model);
        InfraResourceActivityEvent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceActivityEvent>): InfraResourceActivityEvent {
        if (!model) return null;
        return InfraResourceActivityEvent.newInstance(<InfraResourceActivityEvent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceActivityEvent) {
        if (!obj) return;

        models.InfraResourceActivityEvent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceActivityEvent): boolean {
        Object.setPrototypeOf(obj, InfraResourceActivityEvent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.changed_at === "string") {
            this.changed_at = new Date(<string><any>this.changed_at);
        }
    }

    /**
     * Unique change event identifier.
     */
    history_id: string;

    /**
     * Timestamp when the change was detected.
     */
    changed_at: Date;

    /**
     * Type of change: new, modified, discovered
     */
    change_type: string;

    /**
     * Post-change attribute values. Present only in Mode 2 (when event_ids are provided). Removed attributes appear as null.
     */
    changed_attributes: any;

}
